module.exports = __webpack_public_path__ + "static/img/8.020a4f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/ppt/8.jpg
// module id = 1v04
// module chunks = 1